/**
 * Brevity Brew — Enhanced Search v4
 * Popular items panel, trending terms, product-only results
 */

(function () {
  'use strict';

  // ── Config ────────────────────────────────────────────────────────────────
  const POPULAR_COLLECTION = 't-shirts';   // best-selling collection handle
  const POPULAR_LIMIT      = 4;
  const TRENDING_TERMS     = [
    'Coffee', 'Christmas', 'Personalized', 'Cat', 'Dog', 'Funny'
  ];
  // ─────────────────────────────────────────────────────────────────────────

  function buildSearchDrawerEnhancements() {
    const searchEls = document.querySelectorAll('main-search');
    searchEls.forEach((searchEl) => {
      const input = searchEl.querySelector('.main-search__input');
      const resultsBox = searchEl.querySelector('.main-search__results');
      if (!input || !resultsBox) return;

      input.addEventListener('focus', () => {
        if (input.value.trim().length === 0 &&
            !searchEl.classList.contains('main-search--has-results')) {
          showDefaultPanel(searchEl, resultsBox);
        }
      });

      input.addEventListener('keyup', () => {
        if (input.value.trim().length > 0) {
          const panel = resultsBox.querySelector('.bb-default-panel');
          if (panel) panel.remove();
        } else if (input.value.trim().length === 0) {
          if (!resultsBox.querySelector('.bb-default-panel')) {
            showDefaultPanel(searchEl, resultsBox);
          }
        }
      });
    });
  }

  function showDefaultPanel(searchEl, resultsBox) {
    if (searchEl.classList.contains('main-search--has-results') ||
        searchEl.classList.contains('main-search--loading')) return;
    if (resultsBox.querySelector('.bb-default-panel')) return;

    const panel = document.createElement('div');
    panel.className = 'bb-default-panel';

    // Trending searches
    const trendingSection = document.createElement('div');
    trendingSection.className = 'bb-panel-section bb-trending';
    trendingSection.innerHTML = `
      <span class="bb-panel-heading">🔥 Popular Searches</span>
      <div class="bb-trending-terms">
        ${TRENDING_TERMS.map(term =>
          `<a href="/search?q=${encodeURIComponent(term)}&type=product" class="bb-trending-pill">${term}</a>`
        ).join('')}
      </div>
    `;
    panel.appendChild(trendingSection);

    // Popular products
    const productsSection = document.createElement('div');
    productsSection.className = 'bb-panel-section bb-popular-products';
    productsSection.innerHTML = `
      <span class="bb-panel-heading">⭐ Popular Right Now</span>
      <div class="bb-popular-grid bb-popular-grid--loading">
        <div class="bb-popular-skeleton"></div>
        <div class="bb-popular-skeleton"></div>
        <div class="bb-popular-skeleton"></div>
        <div class="bb-popular-skeleton"></div>
      </div>
      <a href="/collections/${POPULAR_COLLECTION}" class="bb-view-all-link">View all products →</a>
    `;
    panel.appendChild(productsSection);

    resultsBox.insertAdjacentElement('afterbegin', panel);
    fetchPopularProducts(productsSection.querySelector('.bb-popular-grid'));
  }

  function fetchPopularProducts(gridEl) {
    // Fetch best-selling products — use sort_by=best-selling for real ordering
    const url = `/collections/${POPULAR_COLLECTION}/products.json?limit=8&sort_by=best-selling`;

    fetch(url)
      .then(r => r.ok ? r.json() : Promise.reject(r.status))
      .then(data => {
        gridEl.classList.remove('bb-popular-grid--loading');
        gridEl.innerHTML = '';

        if (!data.products || data.products.length === 0) {
          gridEl.closest('.bb-popular-products').style.display = 'none';
          return;
        }

        // Deduplicate by title (remove near-duplicates)
        const seen = new Set();
        const unique = data.products.filter(p => {
          // Use first 30 chars of title as dedup key
          const key = p.title.substring(0, 30).toLowerCase();
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        }).slice(0, POPULAR_LIMIT);

        unique.forEach(product => {
          // Get the best image — prefer images over flat mockups
          const img = product.images && product.images[0]
            ? product.images[0].src.replace(/(\.[a-z]+(\?.*)?$)/, '_300x300_crop_center$1')
            : '';

          // Format price correctly from cents
          const priceInCents = product.variants[0].price;
          const price = typeof priceInCents === 'number'
            ? (priceInCents / 100).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
              })
            : `$${priceInCents}`;

          const card = document.createElement('a');
          card.className = 'bb-popular-card';
          card.href = `/products/${product.handle}`;
          card.innerHTML = `
            <div class="bb-popular-card__img-wrap">
              ${img
                ? `<img src="${img}" alt="${product.title}" loading="lazy" width="150" height="150">`
                : '<div class="bb-popular-card__img-placeholder"></div>'}
            </div>
            <div class="bb-popular-card__info">
              <span class="bb-popular-card__title">${product.title.split('|')[0].split('–')[0].trim()}</span>
              <span class="bb-popular-card__price">${price}</span>
            </div>
          `;
          gridEl.appendChild(card);
        });
      })
      .catch(() => {
        if (gridEl.closest('.bb-popular-products')) {
          gridEl.closest('.bb-popular-products').style.display = 'none';
        }
      });
  }

  // ── FILTER SEARCH TO PRODUCTS ONLY ────────────────────────────────────────
  // Intercept the search form to add type=product parameter
  function enforceProductSearchType() {
    document.querySelectorAll('.main-search__form, form[action*="/search"]').forEach(form => {
      if (form.dataset.bbFixed) return;
      form.dataset.bbFixed = '1';

      // Add hidden type field if not present
      if (!form.querySelector('input[name="type"]')) {
        const typeInput = document.createElement('input');
        typeInput.type = 'hidden';
        typeInput.name = 'type';
        typeInput.value = 'product';
        form.appendChild(typeInput);
      }

      // Also intercept the AJAX predictive search to add type filter
      const searchInput = form.querySelector('input[name="q"]');
      if (searchInput) {
        searchInput.addEventListener('keyup', () => {
          // Remove any blog results that sneak into the results box
          setTimeout(() => {
            document.querySelectorAll('.main-search-result--page, .page-block').forEach(el => {
              if (el.closest('.main-search__results')) {
                el.remove();
              }
            });
          }, 600);
        });
      }
    });
  }

  // ── TITLE HIERARCHY ───────────────────────────────────────────────────────
  function applyTitleHierarchy() {
    document.querySelectorAll('.product-title').forEach(function(el) {
      if (el.querySelector('.bb-title-main')) return;
      const raw = el.textContent || el.innerText;
      if (!raw.includes(' | ')) return;

      const parts = raw.split(' | ');
      const main = parts[0].trim();
      const sub  = parts.slice(1).join(' | ').trim();
      const anchor = el.querySelector('a');
      const href = anchor ? anchor.getAttribute('href') : null;

      if (href) {
        el.innerHTML = `<a href="${href}" class="bb-title-link">
          <span class="bb-title-main">${main}</span>
          <span class="bb-title-sub">${sub}</span>
        </a>`;
      } else {
        el.innerHTML = `<span class="bb-title-main">${main}</span>
          <span class="bb-title-sub">${sub}</span>`;
      }
    });
  }

  // ── LIFESTYLE SECTION — hidden until populated ────────────────────────────
  // Section is hidden via CSS — JS still runs but won't show
  function injectLifestyleSection() {
    if (!document.body.classList.contains('template-product')) return;
    if (document.querySelector('.bb-lifestyle-section')) return;
    const productForm = document.querySelector('.js-product');
    if (!productForm) return;

    const section = document.createElement('section');
    section.className = 'bb-lifestyle-section';
    section.style.display = 'none'; // Hidden until customer photos exist
    section.innerHTML = `
      <h2 class="bb-lifestyle-section__heading">See It In Real Life</h2>
      <p class="bb-lifestyle-section__subheading">Real people, real style — find your perfect look</p>
      <div class="bb-lifestyle-grid" id="bb-lifestyle-grid"></div>
    `;
    productForm.insertAdjacentElement('afterend', section);
  }

  // ── CART MESSAGE ENHANCEMENT ─────────────────────────────────────────────
  function enhanceCartMessages() {
    // Find and update the shipping message in cart drawer
    const cartMessages = document.querySelectorAll(
      '.cart-drawer [class*="message"], .cart-drawer [class*="shipping-bar"]'
    );
    cartMessages.forEach(el => {
      const text = el.textContent || '';
      if (text.includes('3-7') || text.includes('3–7')) {
        el.innerHTML = el.innerHTML
          .replace(/3.?7 business days/gi, '7-12 business days')
          .replace(/Ships in 3.?7/gi, 'Made fresh for you · Ships in 7-12');
      }
    });
  }

  // ── RUN ───────────────────────────────────────────────────────────────────
  function init() {
    buildSearchDrawerEnhancements();
    enforceProductSearchType();
    applyTitleHierarchy();
    injectLifestyleSection();
    enhanceCartMessages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  // Re-run cart message fix when cart drawer opens
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-cart], .js-cart-trigger, .header-cart-btn')) {
      setTimeout(enhanceCartMessages, 300);
    }
  });

})();

/* ============================================================
   BREVITY BREW — v5: Thumbnail Arrow Injection
   ============================================================ */
(function() {

  function injectThumbnailArrows() {
    const galleries = document.querySelectorAll('.media-gallery');
    galleries.forEach(function(gallery) {
      const thumbs = gallery.querySelector('.thumbnails');
      if (!thumbs || thumbs.dataset.bbArrows) return;
      thumbs.dataset.bbArrows = '1';

      const sliderGrid = thumbs.querySelector('.slider__grid');
      if (!sliderGrid) return;

      // Create prev button
      const prevBtn = document.createElement('button');
      prevBtn.type = 'button';
      prevBtn.className = 'bb-thumb-arrow bb-thumb-arrow--prev';
      prevBtn.setAttribute('aria-label', 'Previous images');
      prevBtn.innerHTML = `<svg width="10" height="10" viewBox="0 0 10 10" fill="none">
        <path d="M6.5 1.5L3 5l3.5 3.5" stroke="currentColor" stroke-width="1.5"
          stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`;

      // Create next button
      const nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'bb-thumb-arrow bb-thumb-arrow--next';
      nextBtn.setAttribute('aria-label', 'Next images');
      nextBtn.innerHTML = `<svg width="10" height="10" viewBox="0 0 10 10" fill="none">
        <path d="M3.5 1.5L7 5l-3.5 3.5" stroke="currentColor" stroke-width="1.5"
          stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`;

      thumbs.style.position = 'relative';
      thumbs.appendChild(prevBtn);
      thumbs.appendChild(nextBtn);

      // Scroll behavior
      const scrollAmount = 200;
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const slider = thumbs.querySelector('.slider') ||
                       thumbs.querySelector('.slider__grid') || sliderGrid;
        slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const slider = thumbs.querySelector('.slider') ||
                       thumbs.querySelector('.slider__grid') || sliderGrid;
        slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });

      // Show/hide arrows based on scroll position
      function updateArrows() {
        const slider = thumbs.querySelector('.slider') || sliderGrid;
        const atStart = slider.scrollLeft <= 5;
        const atEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 5;
        const hasOverflow = slider.scrollWidth > slider.clientWidth;
        prevBtn.style.display = (hasOverflow && !atStart) ? 'flex' : 'none';
        nextBtn.style.display = (hasOverflow && !atEnd) ? 'flex' : 'none';
      }

      const slider = thumbs.querySelector('.slider') || sliderGrid;
      if (slider) {
        slider.addEventListener('scroll', updateArrows);
        updateArrows();
        // Re-check after images load
        setTimeout(updateArrows, 500);
        setTimeout(updateArrows, 1500);
      }
    });
  }

  // Add arrow CSS
  const arrowStyle = document.createElement('style');
  arrowStyle.textContent = `
    .bb-thumb-arrow {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 10;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      background: #094662;
      color: #fff;
      border: none;
      cursor: pointer;
      display: none;
      align-items: center;
      justify-content: center;
      box-shadow: 0 2px 8px rgba(0,0,0,0.25);
      transition: background 0.15s ease, transform 0.15s ease;
      padding: 0;
    }
    .bb-thumb-arrow:hover {
      background: #063350;
      transform: translateY(-50%) scale(1.1);
    }
    .bb-thumb-arrow--prev { left: -6px; }
    .bb-thumb-arrow--next { right: -6px; }
    .media-gallery:hover .bb-thumb-arrow,
    .thumbnails:hover .bb-thumb-arrow { display: flex; }
  `;
  document.head.appendChild(arrowStyle);

  // Run on load and after dynamic content
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectThumbnailArrows);
  } else {
    injectThumbnailArrows();
  }
  document.addEventListener('shopify:section:load', injectThumbnailArrows);
  // Also run after variant changes which can re-render the gallery
  document.addEventListener('variant:changed', function() {
    setTimeout(injectThumbnailArrows, 300);
  });

})();

/* ============================================================
   BREVITY BREW — Color Swatch Tooltips
   ============================================================ */
(function() {

  function initSwatchTooltips() {
    // Find all swatch filter items
    const swatchItems = document.querySelectorAll(
      '.filter-group--swatch .filter-group__item'
    );

    swatchItems.forEach(function(item) {
      if (item.dataset.tooltipInit) return;
      item.dataset.tooltipInit = '1';

      // Get color name from data-swatch or the hidden text span
      const swatchVal = item.getAttribute('data-swatch') ||
                        item.getAttribute('data-tag') || '';
      const textSpan = item.querySelector('.filter-group__item__text');
      const colorName = textSpan
        ? textSpan.textContent.trim()
        : swatchVal.replace(/-/g, ' ')
            .replace(/\b\w/g, l => l.toUpperCase());

      if (!colorName) return;

      // Set as data attribute for CSS tooltip
      item.setAttribute('data-swatch-label', colorName);

      // Also set native title for accessibility
      item.setAttribute('title', colorName);
    });
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwatchTooltips);
  } else {
    initSwatchTooltips();
  }

  // Re-run when filters update (AJAX)
  document.addEventListener('shopify:section:load', initSwatchTooltips);

  // Watch for filter drawer opening
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-toggle-filters], .filters__open')) {
      setTimeout(initSwatchTooltips, 400);
    }
  });

  // MutationObserver for AJAX filter updates
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        initSwatchTooltips();
      }
    });
  });

  const filtersContainer = document.querySelector('.filters');
  if (filtersContainer) {
    observer.observe(filtersContainer, { childList: true, subtree: true });
  }

})();